import { useTracking } from '@change-corgi/core-react/tracking';

type UseTaglineReturn = ModelHookResult<
	{
		learnMoreLinkHref: string;
	},
	{
		onLearnMoreClick: () => void;
	}
>;

export const useTagline = (): UseTaglineReturn => {
	const track = useTracking();

	return {
		data: {
			learnMoreLinkHref: '/start-a-petition/intro?source_location=homepage_secondary_button',
		},
		actions: {
			onLearnMoreClick: () => {
				void track('homepage_SAP_click', {
					cta: 'secondary',
				});
			},
		},
	};
};
